import { dropdownEllipsisWidth } from "ds/components/DropdownMenu/constants";

export const COLUMN_ORDER = `minmax(40rem, 4.5fr) minmax(30rem, 1fr) minmax(15rem, 1fr) minmax(20rem, 1fr) ${dropdownEllipsisWidth}`;

export const COLUMN_ORDER_PROVIDERS = `minmax(45rem, 7fr) minmax(10rem, 1fr) minmax(20rem, 1fr) ${dropdownEllipsisWidth}`;

export const FILTERS_ORDER_SETTINGS_KEY_PROVIDERS = "providersFiltersOrder";
